import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import usePutData from "../../../../repo/put"; // Hook para PUT

const UpdateButton = ({ data, userId, nome, telefone, cargo, endereco, onUpdateSuccess }) => {
  const { putData, loading } = usePutData();
  const [showDialog, setShowDialog] = useState(false);
  const [error, setError] = useState("");

  const handleUpdate = async () => {
    try {
      // Cria o payload dinamicamente
      const payload = { nome, telefone };
      if (endereco) {
        payload.endereco = endereco; // Adiciona o endereço apenas se ele não for null
      }
  
      const response = await putData(`api/${data}${userId}`, payload);
  
      if (response && response.message) {
        setError("Erro na atualização: " + response.message);
      } else if (response && response.id) {
        if (onUpdateSuccess) {
          onUpdateSuccess(response);
        }
        setError("");
      } else {
        setError("Erro desconhecido ao tentar atualizar o romaneio.");
      }
    } catch (err) {
      setError("Erro ao atualizar romaneio. Tente novamente.");
    }
  };

  const handleConfirmUpdate = () => setShowDialog(true);
  const handleCancelUpdate = () => setShowDialog(false);
  const handleUpdateConfirmed = () => {
    handleUpdate();
    setShowDialog(false);
  };

  const footer = (
    <React.Fragment>
      <Button
        label="Sim"
        icon="pi pi-check"
        onClick={handleUpdateConfirmed}
        className="bg-emerald-500 text-white px-3 py-1 rounded-md shadow hover:bg-green-600 font-bold"
      />
      <Button
        label="Não"
        icon="pi pi-times"
        onClick={handleCancelUpdate}
        className="bg-red-500 text-white px-3 py-1 rounded-md shadow hover:bg-red-600 font-bold"
      />
    </React.Fragment>
  );

  return (
    <div>
      <Button
        onClick={handleConfirmUpdate}
        disabled={loading}
        icon="fa fa-edit"
            className="bg-lightBlue-600 mx-4 text-white px-3 py-1 rounded-md shadow hover:bg-lightBlue-500"
      >
        {loading ? "‎‎  Editando..." : "‎‎  Salva Edição " + cargo}
      </Button>
      <Dialog
        visible={showDialog}
        style={{ width: "300px" }}
        footer={footer}
        onHide={() => setShowDialog(false)}
        header={"Confirma a edição do " + cargo + " ?"}
      >
        <p>Você está certo disso?</p>
        {error && <p className="text-red-500">{error}</p>}
      </Dialog>
    </div>
  );
};

export default UpdateButton;
